module.exports = __webpack_public_path__ + "static/media/FAMI.7c14de72.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/FAMI.jpg
// module id = 1749
// module chunks = 1